/* eslint-disable react-hooks/exhaustive-deps */
import React, { useRef } from "react";
import { useSelector } from "react-redux";

const UnlockPoints = () => {
  const scrollContainerRef = useRef(null);
  const staticPointsData = useSelector(
    (state) => state.staticPointsReducer?.data
  );

  const updatedStaticPoints = Array.isArray(staticPointsData)
    ? staticPointsData.map((item, index) => ({
      ...item,
    }))
    : [];

  const handleClick = (index) => { };

  const handleScrollRight = () => {
    scrollContainerRef.current.scrollBy({
      left: 200,
      behavior: "smooth",
    });
  };
  const handleScrollLeft = () => {
    scrollContainerRef.current.scrollBy({
      left: -200,
      behavior: "smooth",
    });
  };

  function isMobileDevice() {
    return /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
  }

  const divideTextIntoTwoLinesWithoutBreakingWords = (text) => {
    const middleIndex = Math.floor(text.length / 2);

    // Find the nearest space before the midpoint
    let breakIndex = text.lastIndexOf(" ", middleIndex);

    // If no space is found, use the first space after the midpoint
    if (breakIndex === -1) {
      breakIndex = text.indexOf(" ", middleIndex);
    }

    // If still no space is found (single word case), keep the text as is
    if (breakIndex === -1) {
      return [text]; // to return the entire text in one line
    }

    // Divide the text into two parts
    const firstLine = text.slice(0, breakIndex).trim();
    const secondLine = text.slice(breakIndex + 1).trim();

    return [firstLine, secondLine];
  };

  return (
    <section className="py-xl-3 py-2 bg-gray earn">
      <div className="container">
        {Array.isArray(staticPointsData) && staticPointsData.length > 0 && (
          <div key={0} className="mb-3 unlock-point-wrapper">
            <h5 className="sec-below-head">
              <div>
                <span className="title">{staticPointsData[0]?.title}</span>
              </div>

              {/* <span className="subtitle">{staticPointsData[0]?.sub_Title}</span> */}
            </h5>
          </div>
        )}

        <div className="scroll-wrapper">
          <div className="scroll-container" ref={scrollContainerRef}>
            {updatedStaticPoints.length > 0 &&
              updatedStaticPoints.map((item, index) => (
                <div key={index} className="scroll-item">
                  <div
                    className="earn-box d-flex align-items-center unlock-head"
                    onClick={() => handleClick(index)}
                  >
                    <img
                      src={`${process.env.REACT_APP_CLIENT_URL}${item?.icon}`}
                      className="fa-2x mx-31 unlockIcon d-flex align-items-center"
                      //alt={`${index + 1}`}
                      alt={item?.description}
                    />
                    <p className="m-0 align-item-center w-100 unloacDescription"

                    >
                      {divideTextIntoTwoLinesWithoutBreakingWords(
                        item.description
                      ).map((line, lineIndex) => (
                        <React.Fragment key={lineIndex}>
                          <span>{line}</span>
                          {!isMobileDevice() ? <br /> : <>&nbsp;</>}
                        </React.Fragment>
                      ))}
                    </p>
                  </div>
                </div>
              ))}
          </div>

          {Array.isArray(staticPointsData) && staticPointsData.length > 0 && (
            <>
              <button className="scroll-button left" onClick={handleScrollLeft}>
                <i className="fa-solid fa-chevron-left fa-chevron-right-color"></i>
              </button>
              <button className="scroll-button" onClick={handleScrollRight}>
                <i className="fa-solid fa-chevron-right fa-chevron-right-color"></i>
              </button>
            </>
          )}
        </div>
      </div>
    </section>
  );
};

export default UnlockPoints;
